var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',[_c('h1',[_vm._v("Loading...")])]):_c('canvas',{ref:"stockMarket"})
}
var staticRenderFns = []

export { render, staticRenderFns }